import { htmlSanitizer } from '../../../utils/htmlSanitizer';

// The editor indents a block by class, eight levels deep.
const INDENT_CLASSES = Array.from({ length: 8 }, (_, level) => `ql-indent-${level + 1}`);

// The editor writes these: a list item's type, and the four a mention is stored with.
const EDITOR_DATA_ATTR = ['data-list', 'data-id', 'data-value', 'data-index', 'data-denotation-char'];

// The editor's classes a stylesheet here styles or an edit reads back; any other could borrow a page utility.
const KEPT_CLASSES = new Set([
  'mention',
  'ql-syntax', // the older editor's code block, which the comments written with it still carry
  'ql-code-block-container',
  'ql-code-block', // unstyled, but the editor finds a code block's lines by it when an edit reopens the comment
  'ql-font-serif',
  'ql-font-monospace',
  'ql-size-small',
  'ql-size-large',
  'ql-size-huge',
  ...INDENT_CLASSES
]);

// Quill's stylesheet draws a list item's marker from this empty span and positions it absolutely, as it would anything.
const isListMarker = (node: Element) =>
  node.nodeName === 'SPAN' && node.parentElement?.nodeName === 'LI' && !node.hasChildNodes();

/** A comment's HTML with only the markup the Portal's editor writes; its author may be a customer writing to others. */
export const sanitizeCommentHtml = htmlSanitizer(
  {
    ALLOWED_TAGS: 'p br strong em u s a h1 h2 h3 h4 h5 h6 blockquote ol ul li pre code span div img'.split(' '),
    ALLOWED_ATTR: ['href', 'src', 'alt', 'class', ...EDITOR_DATA_ATTR],
    // None of them is a link, and DOMPurify drops a value that reads like one, such as a mention named "Re: Plan".
    ADD_URI_SAFE_ATTR: EDITOR_DATA_ATTR
  },
  (node, data) => {
    if (data.attrName !== 'class') return;
    const kept = data.attrValue
      .split(/\s+/)
      .filter((name) => KEPT_CLASSES.has(name) || (name === 'ql-ui' && isListMarker(node)));
    if (kept.length === 0) data.keepAttr = false;
    else data.attrValue = kept.join(' ');
  }
);
